import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=17368428"
import script from "./EmailDialog.vue?vue&type=script&lang=ts"
export * from "./EmailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports